import { LogOut, ShieldUser } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AddressIcon from '@/assets/store/icon/address-icon.svg';
import EditIcon from '@/assets/store/icon/editprofile-icon.svg';
import RefundIcon from '@/assets/store/icon/refund-icon.svg';
import TransIcon from '@/assets/store/icon/trans-icon.svg';
import { useSessionProfile } from '@/domains/auth/hooks/useSessionProfile';
import ConfirmModal from '@/domains/dashboard-management/components/ConfirmModal/ConfirmModal';
import CardAccount from '@/domains/mobile-web/components/CardAccount/CardAccount';
import CardAffiliate from '@/domains/mobile-web/components/CardAffiliate/CardAffiliate';
import CardSettingAccount from '@/domains/mobile-web/components/CardSettingAccount/CardSettingAccount';
import TopBarHeader from '@/domains/mobile-web/components/TopBarHeader/TopBarHeader';
import { useAffiliate } from '@/domains/mobile-web/hooks/useAffiliate';
import { useCartCount } from '@/domains/mobile-web/hooks/useCart';
import LogoutConfirmModal from '@/shared/components/layout/LogoutConfirmModal/LogoutConfirmModal';
import WrapperMobile from '@/shared/components/layout/WrapperMobile/WrapperMobile';
import Button from '@/shared/components/ui/Button';
import HeaderMobile from '@/shared/components/ui/HeaderMobile/HeaderMobile';
import { useAuthStore } from '@/store/authStore';

const ADMIN_DASHBOARD_ROUTE = '/dashboard/home';

/** Family Members only: the affiliate numbers are asked for once the card is shown. */
const AccountAffiliate = () => {
  const navigate = useNavigate();
  const { data } = useAffiliate();
  return (
    <CardAffiliate
      nominal={Number(data?.available_balance ?? 0)}
      totalClick={data?.click_total ?? 0}
      onClick={() => navigate('/store/affiliate')}
    />
  );
};

const Account = () => {
  const navigate = useNavigate();
  const cartCount = useCartCount();
  useSessionProfile();
  const name = useAuthStore((state) => state.name);
  const email = useAuthStore((state) => state.email);
  const pictureUrl = useAuthStore((state) => state.picture_url);
  const isFamily = useAuthStore((state) => state.membership_tier === 'family');
  const isAdmin = useAuthStore((state) => state.is_admin);
  const [logoutOpen, setLogoutOpen] = useState(false);
  const [adminOpen, setAdminOpen] = useState(false);

  return (
    <>
      <HeaderMobile>
        <TopBarHeader
          type="textBucket"
          totalProduct={cartCount}
          onAction={() => navigate('/store/cart')}
          title="Akun Saya"
        />
      </HeaderMobile>
      <WrapperMobile>
        <CardAccount
          name={name || email}
          email={email}
          pictureUrl={pictureUrl}
          showFamilyMember={isFamily}
        />
        {isFamily && <AccountAffiliate />}
        <CardSettingAccount
          sectionTitle="Pengaturan Akun"
          items={[
            {
              id: 1,
              title: 'Edit Profil',
              icon: EditIcon,
              desc: 'Perbarui informasi pribadi dan akun Anda.',
              onClick: () => navigate('/store/edit-profile'),
            },
            {
              id: 2,
              title: 'Riwayat Transaksi',
              icon: TransIcon,
              desc: 'Lihat dan atur riwayat transaksi belanjaan.',
              onClick: () => navigate('/store/history'),
            },
            // {
            //   id: 3,
            //   title: 'Refund & Pengembalian',
            //   icon: RefundIcon,
            //   desc: 'Lihat dan atur refund & pengembalian.',
            //   onClick: () => navigate('/store/refund-list'),
            // },
            {
              id: 4,
              title: 'Daftar Alamat',
              icon: AddressIcon,
              desc: 'Atur alamat pengiriman belanjaan.',
              onClick: () => navigate('/store/address'),
            },
          ]}
        />

        <Button customButton="btn-fill-red-ghost " onClick={() => setLogoutOpen(true)}>
          <LogOut />
          <span className="title2medium">Keluar Akun</span>
        </Button>
        {isAdmin && (
          <Button customButton="btn-fill-white" onClick={() => setAdminOpen(true)}>
            <ShieldUser className="text-text-blue-100 w-[50px] h-[50px]" />
            <span className="title2medium">Akses Dashboard Admin</span>
          </Button>
        )}
      </WrapperMobile>
      <LogoutConfirmModal open={logoutOpen} onClose={() => setLogoutOpen(false)} />
      <ConfirmModal
        open={adminOpen}
        title="Akses Dashboard Admin?"
        message="Apakah Anda yakin ingin mengakses dashboard admin?"
        confirmLabel="Ya, Akses"
        variant="primary"
        onConfirm={() => navigate(ADMIN_DASHBOARD_ROUTE)}
        onClose={() => setAdminOpen(false)}
      />
    </>
  );
};

export default Account;
